<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">ประเภท Catalog</label>
                  <div class="col-md-8">
                    <catalogtype-selector
                      :reload="reloadCatalogType"
                      :defaultValue="{
                        text: typeName,
                        value: typeId,
                      }"
                      :isDisabled="isDisabled"
                      @selected="onCatalogTypeSelector($event)"
                    >
                    </catalogtype-selector>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">ชื่อ Catalog</label>
                  <div class="col-md-8">
                    <catalog-selector
                      :reload="reloadCatalog"
                      :defaultValue="{
                        text: catalogName,
                        value: catalogId,
                      }"
                      :catalogTypeId="typeId"
                      :isDisabled="isDisabled"
                      @selected="onCatalogSelector($event)"
                    >
                    </catalog-selector>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <validationObserver
              ref="addDataForm"
              tag="form"
              v-if="isCondition"
            >
              <h4 class="card-title mb-4">Catalog Description</h4>
              <form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset">
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">ประเภท</label>
                  <label class="col-form-label col-lg-8">{{
                    model.type.display_name.en
                  }}</label>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">ชื่อ</label>
                  <label
                    class="col-form-label col-lg-8"
                    v-if="model.display_name.th != ''"
                    ><span class="badge-lang">TH</span
                    >{{ model.display_name.th }}</label
                  >
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2"></label>
                  <label
                    class="col-form-label col-lg-8"
                    v-if="model.display_name.en != ''"
                    ><span class="badge-lang">EN</span
                    >{{ model.display_name.en }}</label
                  >
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">วันที่ Catalog</label>
                  <label class="col-form-label col-lg-8">
                    {{ model.catalog_start_date }} -
                    {{ model.catalog_end_date }}
                  </label>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">สถานะ</label>
                  <label class="col-form-label col-lg-8">
                    <label :class="`label label-${statusLabel}`">
                      {{ model.status }}
                    </label>
                  </label>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">จำนวนสินค้าใน Catalog</label>
                  <label class="col-form-label col-lg-8">
                    <label>
                      {{ productTotal | number }}
                    </label>
                  </label>
                </div>
                <br />
                <div
                  class="form-group mb-4 text-right"
                  v-if="model.id !== null"
                >
                  <div class="button-items">
                    <button
                      @click="onExportAll()"
                      v-if="mode !== 'view' && isProductItems"
                      type="button"
                      class="btn btn-success"
                    >
                      <i class="bx bx-export" />Export
                    </button>
                    <button
                      @click="getProductCatalog()"
                      v-if="mode !== 'view' && (!isLoadProductAll || isShowProductByCreated)"
                      type="button"
                      class="btn btn-info"
                    >
                      <i class="bx bx-search" />View Product All
                    </button>
                    <b-dropdown
                      variant="success"
                      v-if="mode !== 'view'"
                      position="bottom-left"
                    >
                      <template slot="button-content"
                        >Manage Product in Catalog<i class="mdi mdi-chevron-down"></i
                      ></template>
                      <b-dropdown-item
                        @click="
                          toggleSideBar = !toggleSideBar
                          modeProduct = 'Add Product'
                        "
                        >Add Product
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          toggleSideBar = !toggleSideBar
                          modeProduct = 'Add Product in Catalog'
                        "
                        >Add Product from Excel
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          toggleSideBar = !toggleSideBar
                          modeProduct = 'Delete Product in Catalog'
                        "
                        >Delete Product from Excel
                      </b-dropdown-item>
                      <!-- <b-dropdown-item
                        @click="
                          toggleSideBar = !toggleSideBar
                          modeProduct = 'Clone'
                        "
                        >Clone
                      </b-dropdown-item> -->
                       <b-dropdown-item
                        @click="
                          toggleSideBar = !toggleSideBar
                          modeProduct = 'Delete All'
                        "
                        >Delete All Product
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <h4 class="card-title mb-4" v-if="model.id !== null && !isLoading && isLoadProductAll">
                  Product
                </h4>
                <div class="form-group row" v-if="model.id !== null && !isLoading && isLoadProductAll">
                  <div class="col-sm-12 col-md-9"></div>
                  <div class="col-sm-12 col-md-3">
                    <div v-if="isProductItems" class="input-group md-form form-sm text-right">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <span class="bx bx-search-alt"></span>
                        </span>
                      </div>
                      <input
                        v-model="filterProductCatalog"
                        class="form-control my-0 py-1"
                        type="search"
                        placeholder="ค้นหารหัสกลุ่มสินค้าหรือรหัสสินค้า"
                        aria-label="Search"
                      />
                    </div>
                  </div>
                  <div v-if="!isLoading && !isProductItems" class="col-sm-12 col-md-12 text-center">
                    <br/>
                    <h5> {{ !isProductItems ? 'ไม่พบข้อมูล' : '' }}</h5>
                  </div>
                </div>
                <div class="row" v-if="model.id !== null">
                  <div class="col-sm-12">
                    <div v-if="isLoading" class="text-center">
                      <b-spinner
                        class="m-2"
                        variant="primary"
                        role="status"
                      ></b-spinner>
                      <span style="display: block;">กำลังโหลดข้อมูล...กรุณารอสักครู่</span>
                    </div>
                    <div v-else class="table-responsive">
                      <!-- :filter="filterProductCatalog" -->
                      <b-table
                        v-if="isProductItems"
                        class="table table-centered table-nowrap"
                        ref="productTable"
                        :empty-text="'ไม่พบข้อมูล'"
                        :show-empty="searchProductItems.length == 0"
                        :bordered="true"
                        :items="searchProductItems"
                        align="center"
                        v-bind:fields="fields"
                        :perPage="perPage"
                        :current-page="pageNo"
                      >
                        <template v-slot:cell(index)="data">
                          <div class="text-right">
                            {{ (firstRowOnPage + data.index) | number }}
                          </div>
                        </template>
                        <template v-slot:cell(inventory_status)="data">
                          <span
                            v-if="data.value"
                            class="label"
                            :class="'label-' + data.value.toLowerCase()"
                            v-html="data.value"
                          ></span>
                        </template>
                        <template v-slot:cell(sale_status)="data">
                          <span
                            v-if="data.value"
                            class="label"
                            :class="'label-' + data.value.toLowerCase()"
                            v-html="data.value"
                          ></span>
                        </template>
                        <!-- <template v-slot:cell(pages)="data">
                          <input
                            v-model="searchProductItems[(firstRowOnPage + data.index) - 1].pages"
                            type="number"
                            class="form-control form-default text-right"
                            min="0"
                          />
                        </template>
                        <template v-slot:cell(remark)="data">
                          <input
                            v-model="searchProductItems[(firstRowOnPage + data.index) - 1].remark"
                            type="text"
                            class="form-control form-default"
                          />
                        </template> -->
                        <!-- <template v-slot:cell(action)="data">
                          <div class="text-center">
                            <a
                              @click="onDeleteProductCatalog(data.item.id)"
                              class="btn btn-ico text-danger"
                              ><i class="bx bx-trash"></i
                            ></a>
                          </div>
                        </template> -->
                      </b-table>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="model.id !== null && isProductItems">
                  <div class="col-lg-4">
                    <div style="position: relative; top: 7px">
                      รายการที่ {{ firstRowOnPage | number }} -
                      {{ lastRowOnPage | number }} จากทั้งหมด
                      {{ totalRecords | number }} รายการ
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <b-pagination
                      :total-rows="totalRecords"
                      :per-page="perPage"
                      v-model="pageNo"
                      @change="onPagination($event)"
                      class="pagination pagination-rounded justify-content-end mb-2"
                    />
                  </div> 
                </div>
                <br />
                <div class="row">
                  <div class="col-md-6">
                    <div class="text-left">
                      <div class="button-items">
                        <button
                          type="button"
                          class="btn btn-light"
                          @click="onCancel()"
                        >
                          <i
                            class="bx bx-arrow-back font-size-16 align-middle mr-2"
                          ></i>
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-right">
                      <!-- <div v-if="isFilterProductCatalog" class="button-items">
                        <button
                          v-if="model.id !== null && mode !== 'view'"
                          type="submit"
                          class="btn btn-primary"
                        >
                          <i class="bx bx-save" />Save
                        </button>
                        <button
                          type="reset"
                          class="btn btn-light"
                          v-if="mode !== 'view'"
                        >
                          <i class="bx bx-reset" />
                          Reset
                        </button>
                      </div> -->
                    </div>
                  </div>
                </div>
              </form>
            </validationObserver>
          </div>
        </div>
      </div>
    </div>
    <sideBar
      v-if="isCatalogId"
      ref="sideBar"
      :toggleSideBar="toggleSideBar"
      :mode="modeProduct"
      :model="model"
      :listProductItems="productItems"
      :catalogIdSelected="catalogId"
      @hidden="toggleSideBar = false"
      @getDataSideBar="getDataSideBar"
    ></sideBar>
    <!-- <sideBar
      ref="sideBar"
      :toggleSideBar="toggleSideBar"
      :mode="modeProduct"
      :listProductItems="productItems"
      :removeCatalogId="catalogId"
      @hidden="toggleSideBar = false"
      @getDataSideBar="getDataSideBar"
    ></sideBar> -->
    <!-- end row -->
  </div>
</template>

<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'

import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import catalogService from '@/helpers/service/catalog-service'
import productService from '@/helpers/service/product-service'
import productCatalogService from '@/helpers/service/product-catalog-service'
import { eventBus } from '@/main.js'
import { StatusEnum } from '@/enum/status.enum.js'
import CatalogTypeSelector from '@/components/catalogtypes/selector'
import CatalogSelector from '@/components/catalog/selector'
import moment from 'moment'
import sideBar from '@/components/product-catalog/sideBar'
import { Workbook } from 'exceljs'
import * as fs from 'file-saver'
import { ExportFileName } from '@/helpers/utils/format-date.js'
// import func from 'vue-editor-bridge'

export default {
  page: {
    title: 'Product Catalog',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    sideBar,
    'catalogtype-selector': CatalogTypeSelector,
    'catalog-selector': CatalogSelector,
  },
  data() {
    return {
      pages: null,
      remark: null,
      id: '',
      title: 'View',
      mode: 'view',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Product Catalog',
          href: '/product-catalogs',
        },
        {
          text: 'View',
          active: true,
        },
      ],
      model: {
        id: null,
        display_name: {
          th: '',
          en: '',
        },
        type: {
          id: '',
          display_name: {
            th: '',
            en: '',
          },
        },
        description: {
          th: '',
          en: '',
        },
        products: [],
        catalog_start_date: '',
        catalog_end_date: '',
        status: StatusEnum.ACTIVE,
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        }
      },
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
        },
        {
          key: 'product_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'sale_status',
          label: 'สถานะการขาย',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'pages',
          label: 'เลขหน้า',
          tdClass: 'text-center',
          thStyle: 'width:120px',
        },
        {
          key: 'remark',
          label: 'หมายเหตุเพิ่มเติม',
        },
        // {
        //   key: 'action',
        //   label: 'Action',
        //   thStyle: 'width:80px',
        // },
      ],
      reloadCatalogType: false,
      reloadCatalog: false,
      perPage: 10,
      pageNo: 1,
      pageSize: 99999,
      totalPages: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
      totalRecords: 0,
      productItems: [],
      listProductItems: [],
      tempProductItems: [],
      typeId: '',
      typeName: '',
      catalogId: '',
      catalogName: '',
      productTotal: 0,
      oldTypeId: '',
      oldTypeName: '',
      oldCatalogId: '',
      oldCatalogName: '',
      isDisabled: false,
      toggleSideBar: false,
      modeProduct: '',
      filterProductCatalog: null,
      isLoading: false,
      resultData: {},
      isLoadProductAll: false,
      isShowProductByCreated: false,
      backRoute: '',
      excel: {
        head_data_validation: {},
        header_excel_style_background_has: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'cc0000' },
        },
        header_excel_style_background: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '4472C4' },
        },
        header_excel_style_font: {
          bold: true,
          size: 12,
          color: { argb: 'ffffff' },
        },
        header_excel: [
          {
            key: 'index',
            value: 'ลำดับ',
          },
          {
            key: 'product_id',
            value: 'รหัสกลุ่มสินค้า',
          },
          {
            key: 'sku_code_ofm',
            value: 'รหัสสินค้า (OFM)',
          },
          {
            key: 'product_display_name.th',
            value: 'ชื่อสินค้า',
          },
          {
            key: 'inventory_status',
            value: 'สถานะสินค้า',
          },
          {
            key: 'sale_status',
            value: 'สถานะการขาย',
          },
          {
            key: 'pages',
            value: 'เลขหน้า',
          },
          {
            key: 'remark',
            value: 'หมายเหตุเพิ่มเติม',
          },
        ],
        template_file_name: 'Data',
      },
    }
  },
  watch: {
    pages: function(value) {
      // if (this.productItems.length > 0) {
      //   if (value === '' || value === null || value === undefined) {
      //     this.productItems.forEach((element, index) => {
      //       element.pages =
      //         this.tempProductItems[index].pages === undefined
      //           ? null
      //           : this.tempProductItems[index].pages
      //     })
      //   } else {
      //     this.productItems.forEach(element => {
      //       if (element.inventory_status !== 'Delete') {
      //         element.pages = value
      //       }
      //     })
      //   }
      // }
      if (this.searchProductItems.length > 0) {
        this.searchProductItems.forEach(element => {
          if (element.inventory_status !== 'Delete') {
            element.pages = value
          }
        })
      }
    },
    // searchProductItems: function(value) {
    //   // console.log('resultData',value)
    //   this.onPagination(1)
    // },
    // resultData: function(value) {
    //   console.log('resultData',value)
    //   this.totalPages = value.totalPages
    //   this.firstRowOnPage = (value.pageNo - 1) * value.pageSize + 1
    //   this.lastRowOnPage =
    //     value.pageSize <= 0
    //       ? value.totalRecords
    //       : Math.min(value.pageNo * value.pageSize, value.totalRecords)
    //   this.totalRecords = value.totalRecords

    //   if (this.showDataTable) {
    //     this.$refs.productCatalogtable.localSortBy = ''
    //   }
    //   // this.items = value.items
    //   // this.perPage = value.pageSize
    //   this.pageNo = value.pageNo
    // },
    remark: function(value) {
      // if (this.productItems.length > 0) {
      //   if (value === '' || value === null || value === undefined) {
      //     this.productItems.forEach((element, index) => {
      //       element.remark =
      //         this.tempProductItems[index].remark === undefined
      //           ? null
      //           : this.tempProductItems[index].remark
      //     })
      //   } else {
      //     this.productItems.forEach(element => {
      //       if (element.inventory_status !== 'Delete') {
      //         element.remark = value
      //       }
      //     })
      //   }
      // }
      if (this.searchProductItems.length > 0) {
        this.searchProductItems.forEach(element => {
          if (element.inventory_status !== 'Delete') {
            element.remark = value
          }
        })
      }
    },
    searchProductItems: function() {
      // console.log('searchProductItems')
      this.onPagination(this.pageNo)
    }
  },
  created: function() {
    if (this.$route.params.id == 'new') {
      this.mode = 'new'
      this.title = 'Edit Product Catalog'
      this.items[2].text = 'New'
      this.isDisabled = false

      if (this.$route.params.catalogId && this.$route.params.catalogId !== '') {
        this.getDetail(this.$route.params.catalogId)
      }
      if (this.$route.params.route && this.$route.params.route !== '') {
        this.backRoute = this.$route.params.route
      }
      
    } else {
      this.title = 'Detail'
      this.items[2].text = 'Detail'
      this.id = this.$route.params.id
      this.isDisabled = true
      if (!this.$route.query.mode) {
        this.fields.splice(
          this.fields.findIndex(element => element.key === 'action'),
          1
        )
      }
    }
    if (this.$route.query.mode) {
      this.title = 'Edit Product Catalog'
      this.items[2].text = 'Edit'
      this.mode = this.$route.query.mode
      this.isDisabled = true
    }
  },
  computed: {
    statusLabel() {
      return this.model !== null && this.model.status !== ''
        ? this.model.status.toLowerCase()
        : ''
    },
    isCatalogId() {
      return this.catalogId !== undefined && this.catalogId !== null && this.catalogId !== ''
    },
    isProductItems() {
      return this.productItems !== undefined && this.productItems !== null && this.productItems.length > 0
    },
    isFilterProductCatalog() {
      return (
        this.filterProductCatalog !== undefined && 
        this.filterProductCatalog !== null && 
        this.filterProductCatalog !== '')
    },
    isCondition() {
      return this.typeId !== undefined 
              && this.typeId !== null 
              && this.typeId !== '' 
              && this.catalogId !== undefined 
              && this.catalogId !== null 
              && this.catalogId !== ''
    },
    searchProductItems() {
      if (this.isProductItems) {
        return this.productItems.filter(q =>  q.product_id !== undefined && q.product_id !== null && q.product_id !== ''
                                              && q.sku_code_ofm !== undefined && q.sku_code_ofm !== null && q.sku_code_ofm !== ''
                                              && (!this.isFilterProductCatalog
                                              || (q.product_id.toLowerCase().includes(this.filterProductCatalog.toLowerCase()) 
                                                  || q.sku_code_ofm.toLowerCase().includes(this.filterProductCatalog.toLowerCase()))))
      }
      return []
    }
  },
  mounted: function() {
    if (this.mode !== 'new') {
      this.getDetail(this.id)
    }
  },
  methods: {
    async onPagination(pageNo) {
        this.pageNo = pageNo
        // this.pageNo = pageNo
        this.totalRecords = this.searchProductItems.length
        this.totalPages = Math.ceil(this.searchProductItems.length / this.perPage)
        this.firstRowOnPage = (pageNo - 1) * this.perPage + 1
        this.lastRowOnPage =
          this.perPage <= 0
            ? this.totalRecords
            : Math.min(pageNo * this.perPage, this.totalRecords)
        

        if (this.showDataTable) {
          this.$refs.productCatalogtable.localSortBy = ''
        }
      // console.log('pageNo',pageNo)
      // console.log('pageNo',this.pageNo)
      // console.log('this.perPage',this.perPage)
      // console.log('this.totalPages',this.totalPages)
      // console.log('this.firstRowOnPage',this.firstRowOnPage)
      // console.log('this.lastRowOnPage',this.lastRowOnPage)
      // console.log('this.totalRecords',this.totalRecords)
    },
    async getProductCatalog() {
      try {
        this.isShowProductByCreated = false
        this.isLoadProductAll = true
        this.isLoading = true
        this.productItems = []
        let params = new URLSearchParams()
        params.append('pageSize', this.pageSize)
        params.append('pageNo', this.pageNo)
        params.append('sort', 'product_id')
        let result = await catalogService.GetCatalogProductsByIdAsync(
          this.catalogId,
          params
        )
        if (result.status === 200) {
          if (result.data.items && result.data.items.length > 0) {
            this.resultData = result.data
            result.data.items.forEach(element => {
              element.skus.forEach(element2 => {
                var displayName = element2.product_names.find(
                  f => f.type === 'Online'
                )
                var tempItem = {
                  id: element2.sku_id,
                  product_id: element.product_id,
                  sku_code_ofm: element2.sku_id,
                  product_display_name: {
                    th: displayName ? displayName.display_name.th : '',
                    en: displayName ? displayName.display_name.en : '',
                  },
                  inventory_status: element2.product_status.inventory,
                  sale_status: element2.product_status.sale,
                  pages:
                    element2.pages && element2.pages.length > 0
                      ? element2.pages[0]
                      : [0],
                  remark: element2.remark,
                }
                this.productItems.push(tempItem)
                // var tempProduct = {
                //   id: element.id,
                //   pages:
                //     element2.pages && element2.pages.length > 0
                //       ? element2.pages[0]
                //       : [0],
                //   remark: element2.remark,
                // }

                // this.tempProductItems.push(tempProduct)
              })
            })
            // console.log('productItems', this.productItems)
          }
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          console.log('error', result.response.data.message)
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          this.$utils.notification('error', result.response.data.message, 2000)
        }
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
        console.log('Error : ', err)
      }
    },
    async getCatalogDetailApi(id) {
      return await catalogService.getCatalogMasterDetailAsync(id)
    },
    async getDetail(id) {
      let result = await this.getCatalogDetailApi(id)
      if (result.status === 200) {
        this.resultData = []
        this.productItems = []
        this.tempProductItems = []
        this.pages = null
        this.remark = null
        this.typeId = result.data.type.id
        this.typeName = result.data.type.display_name.en
        this.catalogId = result.data.id
        this.catalogName = result.data.display_name.en
        this.productTotal = result.data.product_total
        this.model = result.data
        this.model.catalog_start_date = moment(
          this.model.catalog_start_date
        ).format('DD/MM/YYYY')
        this.model.catalog_end_date = moment(
          this.model.catalog_end_date
        ).format('DD/MM/YYYY')

        // await this.getProductCatalog(id)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    // async onGetProduct(value) {
    //   let listSkuId = []
    //   value.forEach(element => {
    //     listSkuId.push(element.sku_id)
    //   })
    //   let objModel = {
    //     sku_id: listSkuId,
    //   }
    //   let result = await productService.searchProductSkuIncludeProductAsync(
    //     objModel
    //   )
    //   if (result.status === 201 || result.status === 200) {
    //     result.data.forEach(element => {
    //       var displayName = element.product_names.find(f => f.type === 'Online')
    //         .display_name
    //       var tempItem = {
    //         id: element.id,
    //         product_id: element.product_id,
    //         sku_code_ofm: element.id,
    //         product_display_name: {
    //           th: displayName.th,
    //           en: displayName.en,
    //         },
    //         inventory_status: element.product_status.inventory,
    //         sale_status: element.product_status.sale,
    //         pages: value.find(f => f.sku_id === element.id).pages,
    //         remark: value.find(f => f.sku_id === element.id).remark,
    //       }

    //       var tempProduct = {
    //         id: element.id,
    //         pages: value.find(f => f.sku_id === element.id).pages,
    //         remark: value.find(f => f.sku_id === element.id).remark,
    //       }
    //       this.productItems.push(tempItem)
    //       this.tempProductItems.push(tempProduct)
    //     })
    //   } else if (
    //     (result.status && result.status === 404) ||
    //     (result.response && result.response.status === 404)
    //   ) {
    //     this.$utils.notification('error', result.response.data.message, 2000)
    //   } else if (
    //     (result.status && result.status !== 500) ||
    //     (result.response && result.response.status !== 500)
    //   ) {
    //     this.$utils.notification('error', result.response.data.message, 2000)
    //   }
    // },
    onCancel() {
      if (this.backRoute !== undefined && this.backRoute !== null && this.backRoute !== '') {
        this.$router.push({
          name: this.backRoute,
          params: { id: this.catalogId }
        })
      } else {
        this.$router.push({
          path: '/product-catalogs',
        })
      }
      
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            if (this.mode === 'new') {
              this.model = {
                id: null,
                display_name: {
                  th: '',
                  en: '',
                },
                type: {
                  id: '',
                  display_name: {
                    th: '',
                    en: '',
                  },
                },
                description: {
                  th: '',
                  en: '',
                },
                products: [],
                catalog_start_date: '',
                catalog_end_date: '',
                status: '',
                create_info: {
                  timestamp: '',
                  user_id: '',
                  user_name: '',
                },
                update_info: {
                  timestamp: '',
                  user_id: '',
                  user_name: '',
                },
              }
              this.reloadCatalogType = true
              this.reloadCatalog = true
              this.resultData = []
              this.productItems = []
              this.tempProductItems = []
              this.pages = null
              this.remark = null
              this.typeId = ''
              this.typeName = ''
              this.catalogId = ''
              this.catalogName = ''
              this.oldTypeId = ''
              this.oldTypeName = ''
              this.oldCatalogId = ''
              this.oldCatalogName = ''
            } else {
              this.getDetail(this.catalogId)
            }
          }
        })
    },
    async onSubmit() {
      this.model.products = []
      this.productItems.forEach(element => {
        var tempListPage = []
        if (
          element.pages !== null &&
          element.pages !== undefined &&
          element.pages !== ''
        ) {
          tempListPage.push(element.pages)
        }
        var tempSku = {
          sku_id: element.id,
          pages: tempListPage,
          remark: element.remark,
        }

        if (this.model.products.length > 0) {
          if (
            this.model.products.findIndex(
              f => f.product_id === element.product_id
            ) !== -1
          ) {
            this.model.products
              .find(f => f.product_id === element.product_id)
              .skus.push(tempSku)
          } else {
            let tempListSku = []
            tempListSku.push(tempSku)
            let product = {
              product_id: element.product_id,
              skus: tempListSku,
            }
            this.model.products.push(product)
          }
        } else {
          let tempListSku = []
          tempListSku.push(tempSku)
          let product = {
            product_id: element.product_id,
            skus: tempListSku,
          }
          this.model.products.push(product)
        }
      })
      this.model.mode = this.modeProduct === 'Delete Product in Catalog' ? 'Delete' : 'Create'
      let result = await productCatalogService.updateProductCatalogAsync(
        this.model.id,
        this.model
      )
      if (result.status && result.status === 204) {
        this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 1500)
        this.$router.push({
          path: '/product-catalogs',
        })
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onCatalogTypeSelector(data) {
      //   this.reloadCatalogType = false
      this.oldTypeId = this.typeId
      this.oldTypeName = this.typeName
      this.typeId = data.value
      this.typeName = data.text

      if (this.productItems.length > 0) {
        await this.$utils
          .confirmAlertDisplay(
            `ต้องการเปลี่ยนประเภท Catalog ที่ต้องการทำงานใช่หรือไม่`,
            ''
          )
          .then(result => {
            if (result) {
              this.resultData = []
              this.productItems = []
              this.tempProductItems = []
              this.pages = null
              this.remark = null
              this.reloadCatalog = true
              this.catalogId = null
              this.catalogName = null
              this.model = {
                id: null,
                display_name: {
                  th: '',
                  en: '',
                },
                type: {
                  id: '',
                  display_name: {
                    th: '',
                    en: '',
                  },
                },
                description: {
                  th: '',
                  en: '',
                },
                products: [],
                catalog_start_date: '',
                catalog_end_date: '',
                status: StatusEnum.ACTIVE,
                create_info: {
                  timestamp: '',
                  user_id: '',
                  user_name: '',
                },
                update_info: {
                  timestamp: '',
                  user_id: '',
                  user_name: '',
                },
              }
            } else {
              this.typeId = this.oldTypeId
              this.typeName = this.oldTypeName
            }
          })
      } else {
        this.reloadCatalog = true
        this.catalogId = null
        this.catalogName = null
        this.model = {
          id: null,
          display_name: {
            th: '',
            en: '',
          },
          type: {
            id: '',
            display_name: {
              th: '',
              en: '',
            },
          },
          description: {
            th: '',
            en: '',
          },
          products: [],
          catalog_start_date: '',
          catalog_end_date: '',
          status: StatusEnum.ACTIVE,
          create_info: {
            timestamp: '',
            user_id: '',
            user_name: '',
          },
          update_info: {
            timestamp: '',
            user_id: '',
            user_name: '',
          },
        }
      }
    },
    async onCatalogSelector(data) {
      this.oldCatalogId = this.catalogId
      this.oldCatalogName = this.catalogName

      this.reloadCatalog = false
      this.catalogId = data.value
      this.catalogName = data.text
      if (this.productItems.length > 0) {
        await this.$utils
          .confirmAlertDisplay(
            `ต้องการเปลี่ยน Catalog ที่ต้องการทำงานใช่หรือไม่`,
            ''
          )
          .then(result => {
            if (result) {
              if (
                this.catalogId !== null &&
                this.catalogId !== '' &&
                this.catalogId !== undefined
              ) {
                this.getDetail(this.catalogId)
              }
            } else {
              this.catalogId = this.oldCatalogId
              this.catalogName = this.oldCatalogName
            }
          })
      } else if (
        this.catalogId !== null &&
        this.catalogId !== '' &&
        this.catalogId !== undefined
      ) {
        this.getDetail(this.catalogId)
      }
    },
    async onDeleteProductCatalog(id) {
      await this.$utils
        .confirmAlertDisplay(`ต้องการลบรายการออกจากชุดข้อมูลนี้ใช่หรือไม่?`, '')
        .then(result => {
          if (result) {
            this.productItems.splice(
              this.productItems.findIndex(element => element.id === id),
              1
            )
          }
        })

      // this.tempProductItems.splice(
      //   this.tempProductItems.findIndex(element => element.id === id),
      //   1
      // )
    },
    onClearProduct() {
      this.resultData = []
      this.productItems = []
      this.tempProductItems = []
      this.pages = null
      this.remark = null
    },
    onExportAll() {
      let workbook = new Workbook()

      let worksheet = workbook.addWorksheet('Data')

      var headerTexts = []
      var headerKeys = []

      this.excel.header_excel.forEach(item => {
        headerTexts.push(item.value)
        headerKeys.push(item.key)
      })

      worksheet.getRow(1).values = headerKeys
      worksheet.getRow(2).values = headerTexts

      worksheet.getRow(1).fill = this.excel.header_excel_style_background
      worksheet.getRow(2).fill = this.excel.header_excel_style_background
      worksheet.getRow(1).font = this.excel.header_excel_style_font
      worksheet.getRow(2).font = this.excel.header_excel_style_font

      // worksheet.getRow(1).values = this.headExcel;

      this.productItems.forEach((data, index) => {
        var tmpDataExorts = []
        tmpDataExorts.push(index + 1)
        tmpDataExorts.push(data.product_id)
        tmpDataExorts.push(data.sku_code_ofm)
        tmpDataExorts.push(data.product_display_name.th)
        tmpDataExorts.push(data.inventory_status)
        tmpDataExorts.push(data.sale_status)
        tmpDataExorts.push(data.pages)
        tmpDataExorts.push(data.remark)
        worksheet.getRow(index + 3).values = tmpDataExorts
      })

      worksheet.columns.forEach(column => {
        const num = column.values[1]
        if (num != undefined) {
          column.width = column.values[1].length
        }
      })

      workbook.xlsx.writeBuffer().then(data => {
        let blob = new Blob([data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        fs.saveAs(blob, ExportFileName(this.excel.template_file_name))
      })
    },
    async getDataSideBar(value) {
      // console.log('value', value)
      // console.log('this.productItems', this.productItems)
      this.filterProductCatalog = ''
      this.productItems = []
      this.isLoadProductAll = false
      this.isShowProductByCreated = false
      if(value !== undefined && value !== null && value.length > 0) {
        // console.log('value', value)
        value.forEach(element => {
          element.pages = parseInt(element.pages)
        });
        this.productItems.push(...value)
        this.isLoadProductAll = true
        this.isShowProductByCreated = true
      }
      let result = await this.getCatalogDetailApi(this.catalogId)
      if (result.status === 200) this.productTotal = result.data.product_total
      
      // value.forEach(element => {
        // if (this.productItems.find(p => p.id === element.id) !== undefined) {
          // this.productItems.find(p => p.id === element.id).product_id =
          //   element.product_id
          // this.productItems.find(p => p.id === element.id).sku_code_ofm =
          //   element.sku_code_ofm
          // this.productItems.find(
          //   p => p.id === element.id
          // ).product_display_name = element.product_display_name
          // this.productItems.find(p => p.id === element.id).inventory_status =
          //   element.inventory_status
          // this.productItems.find(p => p.id === element.id).sale_status =
          //   element.sale_status
          // this.productItems.find(p => p.id === element.id).pages = element.pages
          // this.productItems.find(p => p.id === element.id).remark =
          //   element.remark
          // this.tempProductItems.find(p => p.id === element.id).pages =
          //   element.pages
          // this.tempProductItems.find(p => p.id === element.id).remark =
          //   element.remark
        // } else {
        //   this.productItems.push(element)
        //   var tempProduct = {
        //     id: element.id,
        //     pages: element.pages,
        //     remark: element.remark,
        //   }
        //   // this.tempProductItems.push(tempProduct)
        // }
      // })
      // console.log('this.productItems', this.productItems)
      // this.pages = null
      // this.remark = null
    },
  },
}
</script>
